import React from 'react'

const SingleCollectionBanner = ({ imgUrl, title }) => {
    return (
        <div
            style={{
                position: "relative",
                width: "100%",
                height: "300px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                textAlign: "center",
                color: "white",
                fontSize: "36px",
                fontWeight: "bold",
                marginBottom:'50px'
            }}
        >
            <div
                style={{
                    position: "absolute",
                    width: "100%",
                    height: "100%",
                    backgroundImage: `url(${imgUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    filter: "brightness(0.5)",
                }}
            />

            <div style={{ position: "absolute", bottom: '50px', zIndex: 2 }}>
                {title}
            </div>
        </div>
    )
}

export default SingleCollectionBanner